<div class="jhmi-secure-documents-upload jhm-page">
	<div class="jhm-top-toolbar">
        <div class="left">
          <div class="back">
            <button (click)="goToPreviousPage()">
              <img src="./assets/images/arrow-left.svg">
            </button>
          </div>
          <div class="navigation-item" [class.focus]="selectedPage ==='SECURE_DOCUMENTS_UPLOAD'">
            <button>Upload Documents</button>
          </div>
        </div>
	</div>
    <div class="select-documents">
        <div class="section-title">Document(s)</div>
        <div class="button">
            <button class="action jhm-button white" (click)="selectDocument()"><i class="fa-light fa-files"></i>Select Documents</button>
            <div>{{filename}}</div>
        </div>
        <div class="file-formats">
            We recommend all documents be in PDF format. We accept PDF, PNG, or JPG. 
        </div>
    </div>
    <jhm-select-contact-search [selectedContactId]="selectedContact?.contactId" (contactChange)="selectContact($event)"></jhm-select-contact-search>
    <div class="horizontal-line line"></div>
    @if (isPublicDefender) {
        <div>
            <div>Sending secure documents is free for public defenders</div>
        </div>
    }
    @else {
        <div>
            <div>Cost to send secure documents: $.08 per page</div>
            <div>Cost of this document: {{costOfDocument | centsToDollars}}</div>
        </div>
    }
    <div class="horizontal-line line"></div>
    <div class="upload-actions">
        <button class="action jhm-button primary" [class.disabled]="!filename || !selectedContact" (click)="sendDocuments()"><i class="fa-solid fa-upload"></i>Send Documents</button>
        <button class="action jhm-button primary" [class.disabled]="!filename && !selectedContact" (click)="reset()">Reset</button>
    </div>
</div>
@if (showFilesModal) {
<div class="jhm-modal-background">
	<div id="draft-photos-modal" class="jhm-modal draft-photos-modal">
		<header>
			<h2>Select Document</h2>
			<button class="jhm-button" (click)="showFilesModal = false">
				<img src="./assets/images/black-x.svg">
			</button>
		</header>
        <jhm-upload
          [getFormData]="true"
          (fileData)="setFileData($event)">
        </jhm-upload>
		<footer class="filled">
			<button class="jhm-button"
				(click)="showFilesModal = false;">Cancel</button>
			<!-- <button class="jhm-button primary" (click)="deleteMessage()">Delete</button> -->
		</footer>
	</div>
</div>
}
@if (loading) {
  <jhm-loading></jhm-loading>
}